import { enumify } from '../lib/typeInference.js';

export const segmentTypeValues = ['PERSISTENT', 'ROLLING', 'SCHEDULED'] as const;
export type SegmentType = (typeof segmentTypeValues)[number];
export const SegmentTypeEnum = enumify(segmentTypeValues);

export interface ISegment<IDTYPE> {
    _id: IDTYPE;
    tenantId: IDTYPE;
    title: string;
    description?: string;
    type: SegmentType;
    created: Date;
    updated: Date;
    // deprecated:
    // processed: Date;
    expiryHorizon?: number;
    // deprecated:
    // operator?: 'AND' | 'OR';
    // rules: IDTYPE[];
}
